<template>
  <CHeader>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      aria-label="Open menu"
      @click="$store.commit('toggleSidebarMobile')"
    />

    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      aria-label="Collapse or expand menu"
      @click="$store.commit('toggleSidebarDesktop')"
    />

    <CHeaderNav class="mr-auto">
      <CHeaderNavItem class="px-3">
        <TheHeaderDropdownBusiness></TheHeaderDropdownBusiness>
      </CHeaderNavItem>
      <TheHeaderAppSwitcher />
    </CHeaderNav>

    <CHeaderNav>
      <CHeaderNavItem class="px-3 c-d-legacy-none">
        <button
          @click="() => $store.commit('toggle', 'darkMode')"
          class="c-header-nav-btn"
          :aria-label="$store.state.darkMode ? 'Switch to light mode' : 'Switch to dark mode'"
        >
          <CIcon v-if="$store.state.darkMode" name="cil-sun" />
          <CIcon v-else name="cil-moon" />
        </button>
      </CHeaderNavItem>
      <TheHeaderDropdownAccnt />
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import TheHeaderDropdownBusiness from "./TheHeaderDropdownBusiness";
import TheHeaderAppSwitcher from "./TheHeaderAppSwitcher";

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownBusiness,
    TheHeaderAppSwitcher,
  },
  data: () => {
    return {
      logoUrl: "/img/logo.png",
    };
  },
  computed: {
    userName() {
      try {
        return auth.getUserName();
      } catch (error) {}
      return "Unknown";
    },
    businessName() {
      try {
        return auth.getDefaultBusinessName();
      } catch (error) {}
      return "Unknown";
    },
  },
};
</script>
